var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlooring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiles 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M86.4922 85.4938L85.8313 86.1546L85.1705 85.4938C84.667 84.9903 83.8489 84.9903 83.3454 85.4938C82.8419 85.9973 82.8419 86.8154 83.3454 87.3189L84.0062 87.9797L83.3454 88.6406C82.8419 89.144 82.8419 89.9622 83.3454 90.4657C83.8489 90.9691 84.6671 90.9691 85.1705 90.4657L85.8313 89.8048L86.4922 90.4657C86.9956 90.9691 87.8138 90.9691 88.3173 90.4657C88.8207 89.9622 88.8207 89.144 88.3173 88.6405L87.6565 87.9797L88.3173 87.3189C88.8207 86.8154 88.8207 85.9973 88.3173 85.4938C87.8138 84.9903 86.9956 84.9903 86.4922 85.4938Z",
    fill: "#87D147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M84.0439 14.9277C84.9631 14.9277 85.7083 14.1826 85.7083 13.2634C85.7083 12.3443 84.9631 11.5991 84.0439 11.5991C83.1248 11.5991 82.3796 12.3443 82.3796 13.2634C82.3796 14.1826 83.1248 14.9277 84.0439 14.9277Z",
    fill: "#FF7D91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.391 20.3208C72.3102 20.3208 73.0553 19.5757 73.0553 18.6565C73.0553 17.7373 72.3102 16.9922 71.391 16.9922C70.4718 16.9922 69.7267 17.7373 69.7267 18.6565C69.7267 19.5757 70.4718 20.3208 71.391 20.3208Z",
    fill: "#F5C84C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.39453 41.5039H17.6758V84.668H4.39453V41.5039Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.6758 86.3281H4.39453C3.47771 86.3281 2.73438 85.5848 2.73438 84.668V41.5039C2.73438 40.5871 3.47771 39.8438 4.39453 39.8438H17.6758C18.5926 39.8438 19.3359 40.5871 19.3359 41.5039V84.668C19.3359 85.5848 18.5926 86.3281 17.6758 86.3281ZM6.05469 83.0078H16.0156V43.1641H6.05469V83.0078Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.39453 97.9492V84.668H47.5586V97.9492H4.39453Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.5586 99.6094H4.39453C3.47771 99.6094 2.73438 98.866 2.73438 97.9492V84.668C2.73438 83.7511 3.47771 83.0078 4.39453 83.0078H47.5586C48.4754 83.0078 49.2188 83.7511 49.2188 84.668V97.9492C49.2188 98.866 48.4754 99.6094 47.5586 99.6094ZM6.05469 96.2891H45.8984V86.3281H6.05469V96.2891Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.6758 28.2227H30.957V71.3867H17.6758V28.2227Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.957 73.0469H17.6757C16.7589 73.0469 16.0156 72.3035 16.0156 71.3867V28.2227C16.0156 27.3058 16.7589 26.5625 17.6757 26.5625H30.957C31.8738 26.5625 32.6171 27.3058 32.6171 28.2227V71.3867C32.6171 72.3035 31.8738 73.0469 30.957 73.0469ZM19.3359 69.7266H29.2968V29.8828H19.3359V69.7266Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.6758 84.668V71.3867H60.8398V84.668H17.6758Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M60.8398 86.3281H17.6757C16.7589 86.3281 16.0156 85.5848 16.0156 84.668V71.3867C16.0156 70.4699 16.7589 69.7266 17.6757 69.7266H60.8398C61.7566 69.7266 62.4999 70.4699 62.4999 71.3867V84.668C62.4999 85.5848 61.7566 86.3281 60.8398 86.3281ZM19.3359 83.0078H59.1796V73.0469H19.3359V83.0078Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M30.9572 14.9414H44.2385V58.1055H30.9572V14.9414Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M44.2383 59.7656H30.9571C30.0403 59.7656 29.2969 59.0223 29.2969 58.1055V14.9414C29.2969 14.0246 30.0403 13.2812 30.9571 13.2812H44.2383C45.1552 13.2812 45.8985 14.0246 45.8985 14.9414V58.1055C45.8985 59.0223 45.1552 59.7656 44.2383 59.7656ZM32.6172 56.4453H42.5782V16.6016H32.6172V56.4453Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M30.9572 71.3867V58.1055H74.1213V71.3867H30.9572Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M74.1212 73.0469H30.9571C30.0403 73.0469 29.2969 72.3035 29.2969 71.3867V58.1055C29.2969 57.1886 30.0403 56.4453 30.9571 56.4453H74.1212C75.038 56.4453 75.7813 57.1886 75.7813 58.1055V71.3867C75.7813 72.3035 75.038 73.0469 74.1212 73.0469ZM32.6172 69.7266H72.461V59.7656H32.6172V69.7266Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M44.2385 1.66016H57.5198V44.8242H44.2385V1.66016Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M57.5197 46.4844H44.2384C43.3216 46.4844 42.5782 45.741 42.5782 44.8242V1.66016C42.5782 0.743335 43.3216 0 44.2384 0H57.5197C58.4365 0 59.1798 0.743335 59.1798 1.66016V44.8242C59.1798 45.741 58.4365 46.4844 57.5197 46.4844ZM45.8986 43.1641H55.8595V3.32031H45.8986V43.1641Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M44.2385 58.1055V44.8242H87.4026V58.1055H44.2385Z",
    fill: "#BF7E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M87.4025 59.7656H44.2384C43.3216 59.7656 42.5782 59.0223 42.5782 58.1055V44.8242C42.5782 43.9074 43.3216 43.1641 44.2384 43.1641H87.4025C88.3193 43.1641 89.0626 43.9074 89.0626 44.8242V58.1055C89.0626 59.0223 88.3193 59.7656 87.4025 59.7656ZM45.8986 56.4453H85.7423V46.4844H45.8986V56.4453Z",
    fill: "black"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlooring);
export default __webpack_public_path__ + "static/media/flooring.677945372d3c432667afe5a43d12784e.svg";
export { ForwardRef as ReactComponent };